
import { Link } from 'react-router-dom';

export default function Mining() {
  const services = [
    {
      icon: 'ri-recycle-line',
      title: 'Waste-to-Value Transformation',
      description: 'We acquire raw materials from mining companies that would otherwise be considered waste, transforming them into premium chrome concentrate through innovative processing.',
      stat: '100%',
      statLabel: 'Value Recovery'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Chrome Ore Beneficiation',
      description: 'Our Rustenburg plant beneficiates ROM (Run of Mine) into high-quality chrome concentrate, producing an average of 1,000 MT of final product on a weekly basis.',
      stat: '1000',
      statLabel: 'MT Weekly'
    },
    {
      icon: 'ri-truck-line',
      title: 'Raw Material Sourcing',
      description: 'TMI sources raw material from various mines and dumps located around Northwest Province, with supply points 70 to 120km from our processing plant.',
      stat: '120km',
      statLabel: 'Supply Radius'
    },
    {
      icon: 'ri-hand-coin-line',
      title: 'Commodity Trading',
      description: 'Over 8 years facilitating syndications and business linkages between buyers and sellers of chrome and other commodities across local and international markets.',
      stat: '8+',
      statLabel: 'Years Trading'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Plant Consultancy',
      description: 'TMI builds chrome processing plants and beneficiates chrome ore on a consultancy basis for clients, leveraging deep industry expertise and proven methodologies.',
      stat: '40+',
      statLabel: 'Years Expertise'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Direct-from-Source Sales',
      description: 'Clients buy directly from our processing site at competitive prices — bypassing big mining houses for significant cost savings on quality chrome products.',
      stat: '100%',
      statLabel: 'Client Focused'
    }
  ];

  return (
    <section id="mining" className="py-24 bg-[#FAFAF8]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start justify-between mb-14 gap-4">
          <div>
            <div className="inline-block bg-[#F5E6EA] text-[#8B1538] px-5 py-2 rounded-full text-sm font-semibold mb-4">
              CHROME PROCESSING
            </div>
            <h2 className="text-4xl md:text-5xl font-bold font-['Montserrat'] leading-tight">
              <span className="text-[#2C3E50]">What We </span>
              <span className="text-[#8B1538]">Do</span>
            </h2>
          </div>
          <Link
            to="/mining"
            className="mt-2 md:mt-6 text-[#8B1538] font-semibold inline-flex items-center gap-2 hover:gap-3 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-[0_2px_16px_rgba(0,0,0,0.05)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.1)] transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#F5E6EA] rounded-xl mb-6 group-hover:bg-[#8B1538] transition-colors duration-300">
                <i className={`${service.icon} text-2xl text-[#8B1538] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#2C3E50] mb-3 font-['Montserrat']">
                {service.title}
              </h3>
              <p className="text-sm text-[#5A6C7D] leading-relaxed font-['Lato'] mb-6">
                {service.description}
              </p>
              <div className="pt-4 border-t border-gray-100 flex items-end gap-2">
                <span className="text-2xl font-bold text-[#8B1538] font-['Montserrat']">{service.stat}</span>
                <span className="text-xs text-gray-500 mb-1 uppercase tracking-wider">{service.statLabel}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
